// import FieldModel from '../authorityManage/fieldModel.vue';
import oneLevelModel from './oneLevelModel';
import twoLevelModel from './twoLevelModel';
import subordinateModel from './subordinateModel';
import { menuList, menuDelete, menuDetail } from './request';
export default {
  components: {
    oneLevelModel,
    subordinateModel,
    twoLevelModel
  },
  data() {
    return {
      currentRow: false,
      dialogVisible: false,
      subordinateVisible: false,
      dialogVisible2: false,
      currentRow2: false,
      form: {
        isOpen: 0
      },
      columns: [{
        slots: {
          title: '菜单名称'
        },
        dataIndex: 'name',
        key: 'name',
        width: 200,
        scopedSlots: {
          customRender: 'commonText'
        }
      }, {
        slots: {
          title: '菜单类型'
        },
        dataIndex: 'position',
        key: 'position',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'position'
        }
      }, {
        slots: {
          title: '请求地址'
        },
        dataIndex: 'link',
        key: 'link',
        align: 'center',
        width: 200
      }, {
        slots: {
          title: '菜单标识'
        },
        dataIndex: 'mark',
        key: 'mark',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '备注'
        },
        dataIndex: 'remark',
        key: 'remark',
        align: 'center',
        ellipsis: true,
        scopedSlots: {
          customRender: 'commonText'
        }
      }, {
        slots: {
          title: '客户是否可见'
        },
        dataIndex: 'isOpen',
        key: 'isOpen',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'isOpen'
        }
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'isShow',
        key: 'isShow',
        align: 'center',
        width: 80,
        scopedSlots: {
          customRender: 'isShow'
        }
      }, {
        slots: {
          title: '操作'
        },
        dataIndex: 'operation',
        key: 'operation',
        align: 'center',
        width: 320,
        scopedSlots: {
          customRender: 'action'
        },
        fixed: 'right'
      }],
      data: []
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    getDataFun() {
      menuList(this.form).then(res => {
        console.log(res);
        this.data = res;
      });
    },
    oneLevelFun(val) {
      this.currentRow = val;
      this.dialogVisible = true;
    },
    twoLevelFun(val) {
      this.currentRow2 = val;
      this.dialogVisible2 = true;
    },
    addsSubordinate(val, type) {
      this.subordinateVisible = true;
      console.log(val);
      this.$nextTick(() => {
        this.$refs.subordinateRef.init(val, type);
      });
    },
    customerFun(val) {
      menuDetail({
        menuId: val.id
      }).then(res => {
        console.log(res);
        if (val.position == '1') {
          this.oneLevelFun(res);
        } else if (val.position == 2 && val.parentId == 0) {
          this.twoLevelFun(res);
        } else {
          this.addsSubordinate(res, 'edit');
        }
      });
    },
    delItem(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该菜单') + '?', {
        confirmButtonText: this.$t('确定')
      }).then(() => {
        menuDelete({
          menuId: val.id
        }).then(res => {
          _this.$message.success(this.$t('删除成功'));
          _this.getDataFun();
        });
      });
    }
  }
};